function add (initValue, arg) { // 加法
  return (Math.round(initValue * 100) + Math.round(arg * 100)) / 100
}
function subtract (arg1, arg2) { // 减
 let r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  // last modify by deeka
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

function multiple (arg1, arg2) { // 乘
    var baseNum = 0
    try {
      baseNum += arg1.toString().split('.')[1].length
    } catch (e) {
    }
    try {
      baseNum += arg2.toString().split('.')[1].length
    } catch (e) {
    }
    return Number(arg1.toString().replace('.', '')) * Number(arg2.toString().replace('.', '')) / Math.pow(10, baseNum)
}
function divide (arg1, arg2) { // 除
  let d1, d2,
    n1 = Number(arg1.toString().replace('.', '')),
    n2 = Number(arg2.toString().replace('.', ''))
  try { d1 = arg1.toString().split('.')[1].length } catch (e) { d1 = 0 }
  try { d2 = arg2.toString().split('.')[1].length } catch (e) { d2 = 0 }
  return toFixed((n1 / n2) * Math.pow(10, d2 - d1), 2)
}
function toFixed (arg, n) {
  if (n == 0) {
    return Math.round(arg)
  }
  try {
    let d, carryD,
      ds = arg.toString().split('.'),
      len = ds[1].length,
      b0 = '', k = 0
    if (len > n) {
      while (k < n && ds[1].substring(0, ++k) == '0') {
        b0 += '0'
      }
      d = Number(ds[1].substring(0, n))
      carryD = Math.round(Number('0.' + ds[1].substring(n, len)))
      len = (d + carryD).toString().length
      if (len > n) {
        return Number(ds[0]) + 1
      } else if (len == n) {
        return Number(ds[0] + '.' + (d + carryD))
      }
      return Number(ds[0] + '.' + b0 + (d + carryD))
    }
  } catch (e) {}
  return arg
}

Number.prototype.add = function (arg) {
  return add(this, arg)
}
Number.prototype.jcSubtract = function (arg) {
  return subtract(this, arg)
}
Number.prototype.multiple = function (arg) {
  return multiple(this, arg)
}
Number.prototype.divide = function (arg) {
  return divide(this, arg)
}



// WEBPACK FOOTER //
// ./src/utils/mixins/number_opration.js